import React, {useMemo, useState, useEffect, useContext} from "react";
import TerminalDetailsTabs from "./TerminalDetailsTab";
import DataTable from 'react-data-table-component';


import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import { useHistory } from "react-router-dom";
import axios from "axios";
import {TerminalDataTableListMgmtApi, TerminalMgmtApi} from "../Api";
import {terminalListContext} from "../App";

function Table({ columns, data }) {

  const history = useHistory();
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useGlobalFilter,
      useSortBy,
      usePagination
    );
  const handleRowClick = (data) => {
    console.log("Terminal Details Page",data);
    history.push({
      pathname: "/termManagement/terMinalDetails",
      search: `terminalID=${data.terminalID}`,
    });
  };


  return (
    <>
      <div className="report_table_outer" style={{height: "850px" , overflow: "scroll"}}>
        <div className="table-responsive" style={{fontSize:"10px"}}>
          <table
            {...getTableProps()}
            className="table table-hover table-responsive table-sm"
          >
            <thead className="thead-light">
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} style={{fontSize:"10px"}}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <svg
                              className="th-align-left"
                              focusable="false"
                              xmlns="http://www.w3.org/2000/svg"
                              width="14px"
                              height="14px"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                            </svg>
                          ) : (
                            <svg
                              className="th-align-right"
                              focusable="false"
                              xmlns="http://www.w3.org/2000/svg"
                              width="14px"
                              height="14px"
                              fill="currentColor"
                              class="bi bi-caret-up-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                            </svg>
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    onClick={() => handleRowClick(row.original)}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function TerminalDetailPage(props) {
    const {terminalList:terminalListData, setTerminalList:setTerminalListData}  = useContext(terminalListContext);
    console.log("------ terminalListData",terminalListData)
  //const [terminalListData, setTerminalListData] = useState([]);
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [pending, setPending] = React.useState(true);
    const history = useHistory();
    const handleRowClick = (data) => {
        console.log("Terminal Details Page",data);
        history.push({
            pathname: "/termManagement/terMinalDetails",
            search: `terminalID=${data.terminalID}`,
        });
    };

    //  Internally, customStyles will deep merges your customStyles with the default styling.


    /**Custom table code*/
    const datacolumns = [
        {
            name: 'Error ',
            width: "30px",
            font:'5px',
            selector: row => row.generalStatus.includes("Not Live")?<img
                src="/assets/images/icons/shield-black.png"
                height="10"
                width="10"
            />:<img
                src="/assets/images/icons/shield-grey.png"
                height="10"
                width="10"
            />,
            fixedHeader:true,
        },
        {
            name: 'Cash ',
            width: "40px",
            selector: row => row.cashStatus.includes("GOOD")?<img
                src="/assets/images/icons/shield-green.png"
                height="10"
                width="10"
            />:<img
                src="/assets/images/icons/shield-red.png"
                height="10"
                width="10"
            />,
        },
        {
            name: 'Terminal',
            width: "70px",
            font:'5px',
            selector: row => (
                <h8
                    style={{
                        color: "blue",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "normal",
                        fontSize: "10px",
                    }}
                    onClick={() => handleRowClick(row)}
                >
                    {row.terminalID}
                </h8>
            ),
            sortable: true,
        },
        {
            name: 'Location ',
            fontSize: "10px",
            selector: row => (
                <h6
                    style={{
                        fontWeight: "normal",
                        fontSize: "10px",
                    }}
                >
                    {row.locationName}
                </h6>
            ),
            sortable: true,
        }
        ];


  const TerminalListColumn = useMemo(
    () => [
        {
            Header: "Error",
            accessor: "generalStatus",
            Cell: (props) => (
                <h6
                    style={{
                        fontWeight: "normal",
                        fontSize: "10px",
                    }}
                >
                    {props.value.includes("Not Live")?<img
                        src="/assets/images/icons/shield-black.png"
                        height="10"
                        width="10"
                    />:<img
                        src="/assets/images/icons/shield-grey.png"
                        height="10"
                        width="10"
                    />}
                </h6>
            ),
        },
        {
            Header: "Cash",
            accessor: "cashStatus",
            Cell: (props) => (
                <h6
                    style={{
                        fontWeight: "normal",
                        fontSize: "10px",
                    }}
                >
                    {props.value.includes("GOOD")?<img
                        src="/assets/images/icons/shield-green.png"
                        height="10"
                        width="10"
                    />:<img
                        src="/assets/images/icons/shield-red.png"
                        height="10"
                        width="10"
                    />}
                </h6>
            ),
        },
      {
        Header: "Terminal_ID",
        accessor: "terminalID",
          width: "70px",
          font:'5px',
        Cell: (props) => (
          <h6
            style={{
              color: "blue",
              cursor: "pointer",
              fontSize: "10px",
            }}
          >
            {props.value}
          </h6>
        ),
      },
      {
        Header: "Location",
        accessor: "locationName",
          Cell: (props) => (
              <h6
                  style={{
                      fontWeight: "normal",
                      fontSize: "10px",
                  }}
              >
                  {props.value}
              </h6>
          ),
      },
    ],
    []
  );

    const TableComponent = () => (
        <div className="col-xl-3">
            <div className="card">
                {/* <div className="card-body"> */}
                <span
                    class="d-block p-2 text-white"
                    style={{ background: "#002170" }}
                >
      Terminal List
    </span>
                <Table columns={TerminalListColumn} data={terminalListData} />

            </div>
        </div>
    )
    const TableList = useMemo(()=><TableComponent/> ,[terminalListData])

  useEffect(() => {
      console.log("result props for details",props)
      setPending(false);
    /*const fetchTerminalList = async () => {
      /!*const result = await axios.get(`${TerminalMgmtApi}?id=${loggedUserStorage}&searchCriteria=""&lastTxn=10&pageSize=50000&currentPage=1&sortColumn=TerminalID&sortOrder=DESC`,{
          mode: 'no-cors' // 'cors' by default
      });*!/
       /!* let resultTerminal = await axios.get(`${TerminalDataTableListMgmtApi}?id=${loggedUserStorage}&parentUserId=${loggedUserStorage}`,{
            mode: 'no-cors' // 'cors' by default
        });*!/

      //setTerminalListData(resultTerminal.data.response);
        setPending(false);
    };
    fetchTerminalList();*/
  }, []);
  return (
    <div className="row">
      <div className="col-xl-9">
        <div className="card">
          <div className="card-body">
            <TerminalDetailsTabs terminalsData={terminalListData} />
          </div>
        </div>
      </div>
      {/*<div className="col-xl-3">
        <div className="card">
           <div className="card-body">
          <span
            class="d-block p-2 text-white"
            style={{ background: "#002170" }}
          >
            Terminal List
          </span>
          <Table columns={TerminalListColumn} data={terminalListData} />
            {<DataTable
                columns={datacolumns}
                data={terminalListData}
                progressPending={pending}
                customStyles={customStyles}
            />}
        </div>
      </div>*/}
        {TableList}
    </div>
    // </div>
  );
}

export default TerminalDetailPage;
